import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import type { RootState } from "../redux/store";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
}) => {
  //console.count("ProtectedRoute render");	
  const navigate = useNavigate();
  const hasRedirected = useRef(false);

  const user = useSelector((state: RootState) => state.user.user);
  const loggedIn = Boolean(localStorage.getItem("token"));
  //console.log("ProtectedRoute render user", user);
  //console.log("ProtectedRoute render loggedIn", loggedIn);
  useEffect(() => {
    if (hasRedirected.current) return;

    if (!loggedIn) {
      hasRedirected.current = true;
      navigate("/login", { replace: true });
      return;
    }

    /*if (!allowedRoles.includes(user.rolename)) {
      hasRedirected.current = true;
      navigate("/login", { replace: true });
    }*/
  }, [loggedIn]);

  // While redirecting or checking auth → render nothing
  if (!loggedIn || !user) return null;

  return <>{children}</>;
};

export default ProtectedRoute;